<div class="min-h-screen bg-gray-50 flex flex-col font-prompt relative overflow-x-hidden pb-12">
    <!-- Decorative background elements -->
    <div
        class="absolute top-0 right-0 w-32 h-32 bg-amber-400 rounded-full mix-blend-multiply filter blur-2xl opacity-10 -translate-y-1/2 translate-x-1/2 pointer-events-none">
    </div>
    <div
        class="absolute top-48 left-0 w-24 h-24 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-10 -translate-x-1/2 pointer-events-none">
    </div>

    <!------------------------------------------ Header Section ------------------------------------>
    <div class="bg-(--background-color) rounded-b-[2rem] shadow-md pb-8 pt-5 px-4 relative z-10">
        <!-- Back Button -->
        <div class="absolute left-4 top-5 w-[40px] h-[40px] bg-white/10 hover:bg-white/20 text-white rounded-full shadow-md flex justify-center items-center cursor-pointer active:scale-95 transition-all z-20 backdrop-blur-sm border border-white/10"
            (click)="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor" class="w-5 h-5 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
        </div>

        <!-- Header Titles -->
        <div class="text-center mt-1 px-10">
            <h1 class="text-lg font-bold text-(--main-text-color) tracking-wide">
                {{ currentLang === "TH" ? "เติมเงิน EV Charger" : "EV Charger Top Up" }}
            </h1>
            <p class="text-xs text-(--sub-text-color) mt-1.5 leading-relaxed">
                {{ currentLang === "TH"
                ? "เติมเงินสะสมสำหรับใช้บริการชาร์จรถไฟฟ้า"
                : "Top up pocket balance for EV charging services" }}
            </p>
        </div>

        <!------------------------------------------ EV Wallet Card ------------------------------------>
        <div class="w-full px-4 mt-6 animation-slide-up">
            <div
                class="w-full bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700/50 rounded-3xl p-5 shadow-2xl relative overflow-hidden text-white group">
                <!-- Bolt Watermark Graphic -->
                <div
                    class="absolute -right-2 -bottom-6 text-white/5 pointer-events-none transform -rotate-20 transition-transform duration-500 group-hover:scale-110">
                    <img src="icons/electric_bolt_slate.svg" class="w-34 h-34 opacity-10" />
                </div>

                <!-- Top Row: Card Title & Account Tag -->
                <div class="flex items-center justify-between relative z-10">
                    <div class="flex items-center gap-2">
                        <img src="icons/electric_car_orange.svg" class="w-8 h-8" />
                        <span class="text-[10px] font-bold tracking-widest text-slate-300 uppercase">EV Wallet
                            Card</span>
                    </div>
                    <div
                        class="bg-amber-400/10 border border-amber-400/20 px-2.5 py-0.5 rounded-full flex items-center justify-center">
                        <span class="text-[9px] font-bold text-amber-400 tracking-wider">NO. {{
                            topUpAccount?.accountNumber }}</span>
                    </div>
                </div>

                <!-- Balance Display -->
                <div class="mt-5 relative z-10">
                    <span class="text-[10px] font-medium text-slate-400 block uppercase tracking-wider">
                        {{ currentLang === "TH" ? "ยอดเงินคงเหลือ" : "Pocket Balance" }}
                    </span>
                    <div class="flex items-baseline gap-1 mt-1">
                        <span class="text-3xl font-extrabold text-white tracking-wide">
                            {{ topUpAccount?.amount | number : "1.2-2" }}
                        </span>
                        <span class="text-xs font-bold text-amber-400 uppercase">THB</span>
                    </div>
                </div>

                <!-- Card Bottom: User Name & Refresh Button -->
                <div class="flex items-center justify-between mt-6 pt-4 border-t border-slate-700/40 relative z-10">
                    <div class="flex flex-col text-left">
                        <span class="text-[9px] text-slate-500 font-bold tracking-wider uppercase">{{ currentLang ===
                            "TH" ? "ผู้ถือบัญชี" : "Card Holder" }}</span>
                        <span class="text-xs font-bold text-slate-300 truncate max-w-[160px]">{{
                            topUpAccount?.accountName }}</span>
                    </div>
                    <!-- Reload button -->
                    <button (click)="getTopUpAccount()"
                        class="w-8 h-8 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-300 flex items-center justify-center shadow transition-all active:scale-90 border border-slate-700/50">
                        <img src="icons/sync_slate.svg" />
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!---------------------------------------- Segments Tab Selector ------------------------------------>
    <div class="px-4 mt-6 mb-4 animation-slide-up delay-200">
        <div class="bg-slate-100 p-1 rounded-2xl flex items-center shadow-inner">
            <button
                class="flex-grow py-2.5 text-xs font-bold rounded-xl bg-white text-slate-800 shadow-sm transition-all text-center">
                {{ currentLang === "TH" ? "เติมเงิน" : "Top Up" }}
            </button>
            <button (click)="goToTarnsition()"
                class="flex-grow py-2.5 text-xs font-medium rounded-xl text-slate-500 hover:text-slate-700 transition-all text-center">
                {{ currentLang === "TH" ? "ประวัติการโอนเงิน" : "Transfer History" }}
            </button>
        </div>
    </div>

    <div class="px-4 space-y-4 animation-slide-up delay-200">
        <!---------------------------------------- Card 1: User Profile Details ------------------------------------>
        <!-- <div class="bg-white rounded-2xl border border-slate-100/60 p-4 shadow-sm flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-amber-500 flex-shrink-0">
                <span class="material-symbols-outlined">person</span>
            </div>
            <div class="flex flex-col text-left">
                <span class="text-[9px] text-slate-400 font-bold uppercase tracking-wider">{{ currentLang === "TH" ? "ชื่อบัญชีผู้ใช้งาน" : "Fristname Lastname" }}</span>
                <span class="text-sm font-bold text-slate-700">{{ topUpAccount?.accountName }}</span>
            </div>
        </div> -->

        <!---------------------------------------- Card 2: Payment Methods Selector (Hidden for now) ------------------------------------>
        <!-- <div class="bg-white rounded-2xl border border-slate-100/60 p-4 shadow-sm space-y-3">
            <span class="text-[10px] font-bold text-slate-400 uppercase tracking-wider block text-left">
                {{ currentLang === "TH" ? "ช่องทางการชำระเงิน" : "Payment Options" }}
            </span>
            <div class="grid grid-cols-2 gap-3">
                <div (click)="paymentSelect = 2"
                    class="border-2 rounded-2xl p-4 flex flex-col items-center justify-center gap-2 cursor-pointer transition-all duration-300 relative overflow-hidden select-none"
                    [ngClass]="paymentSelect === 2 ? 'border-amber-400 bg-amber-500/5 shadow-md scale-[1.01]' : 'border-slate-100 bg-white hover:border-slate-200'">
                    <div *ngIf="paymentSelect === 2" class="absolute top-2 right-2 text-amber-500">
                        <span class="material-symbols-outlined text-lg">check_circle</span>
                    </div>
                    <img src="icons/Payment/thaiQR_logo.png" alt="Thai QR" class="h-10 object-contain rounded-lg" />
                    <span class="text-xs font-bold text-slate-700">Thai QR Payment</span>
                </div>

                <div
                    class="border-2 border-slate-100 rounded-2xl p-4 flex flex-col items-center justify-center gap-2 cursor-not-allowed bg-slate-50 opacity-60 relative select-none">
                    <img src="icons/Payment/true-logo.png" alt="TrueMoney" class="h-10 object-contain" />
                    <span class="text-xs font-bold text-slate-400">TrueMoney Wallet</span>
                    <span
                        class="absolute top-1.5 right-2 text-[8px] bg-slate-200 text-slate-600 px-1.5 py-0.5 rounded-full font-bold uppercase tracking-widest scale-90">Soon</span>
                </div>
            </div>
        </div> -->

        <!---------------------------------------- Card 3: Topup Amount Configuration ------------------------------------>
        <div class="bg-white rounded-2xl border border-slate-100/60 p-4 shadow-sm space-y-4">
            <div class="flex flex-col text-left">
                <span class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                    {{ currentLang === "TH" ? "จำนวนเงินที่ต้องการเติม" : "Amount" }}
                </span>
                <div class="relative flex items-center">
                    <span class="absolute left-0 text-lg font-bold text-slate-400 z-10">฿</span>
                    <div class="w-full pl-6">
                        <app-input
                            [placeholder]="currentLang === 'TH' ? 'กรุณากรอกจำนวนเงิน' : 'Please enter the amount'"
                            [valueIn]="total" [validateType]="'number'" [validateName]="'total'"
                            [validateIn]="validateNumber" (valueOut)="total = $event"
                            (validateOut)="validateNumber = { where: $event.where, result: $event.result }">
                        </app-input>
                    </div>
                </div>
                <p class="text-[10px] text-slate-400 mt-2">
                    {{ currentLang === "TH"
                    ? "*ขั้นต่ำไม่น้อยกว่า 10 บาท และสูงสุดไม่เกิน 1,000 บาท"
                    : "*Min 10 THB, Max 1,000 THB" }}
                </p>
            </div>

            <!-- Preset Amount Buttons Grid -->
            <div class="grid grid-cols-3 gap-3">
                <button *ngFor="let amount of [60, 100, 200, 250, 300, 400, 500, 1000]"
                    (click)="handleAmountClicked(amount)"
                    class="py-2.5 text-xs font-bold rounded-xl transition-all border duration-200 active:scale-95 flex items-center justify-center"
                    [ngClass]="total === amount ? 'bg-amber-400 border-amber-400 text-slate-800 shadow-sm font-extrabold scale-[1.02]' : 'bg-slate-50 border-slate-100 text-slate-600 hover:bg-slate-100'">
                    {{ amount | number }}
                </button>
                <button (click)="changeToFixedAmount()"
                    class="py-2.5 text-xs font-bold rounded-xl transition-all border duration-200 active:scale-95 flex items-center justify-center"
                    [ngClass]="isFixedAmount ? 'bg-amber-400 border-amber-400 text-slate-800 shadow-sm font-extrabold scale-[1.02]' : 'bg-slate-50 border-slate-100 text-slate-600 hover:bg-slate-100'">
                    {{ currentLang == "TH" ? "กำหนดราคา" : "Fixed" }}
                </button>
            </div>
        </div>

        <!---------------------------------------- Payment Policy / Disclaimer Warning ------------------------------------>
        <div class="bg-amber-50/50 border border-amber-100 rounded-2xl p-4 flex items-start gap-3 shadow-sm text-left">
            <div (click)="paymentPolicy = !paymentPolicy"
                class="w-5 h-5 rounded-lg border flex items-center justify-center flex-shrink-0 cursor-pointer transition-all duration-200"
                [ngClass]="paymentPolicy ? 'bg-amber-400 border-amber-400 text-slate-800' : 'bg-white border-slate-300'">
                <svg *ngIf="paymentPolicy" class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <div class="flex-1 text-xs leading-relaxed text-slate-600">
                <span class="font-bold text-red-500">{{ currentLang === "TH" ? "ข้อตกลงสำคัญ: " : "Notice: " }}</span>
                <span *ngIf="currentLang === 'TH'">
                    การเติมเงินนี้ใช้สำหรับใช้<span class="text-blue-600 font-black"> บริการชาร์จรถไฟฟ้า (EV Charger)
                    </span> เท่านั้นไม่สามารถขอคืนหรือถอนเป็นเงินสดได้ในภายหลัง
                </span>
                <span *ngIf="currentLang !== 'TH'">
                    This top-up is strictly for <span class="text-amber-655 font-black">EV Charging services</span> and
                    is non-refundable or withdrawable under any circumstances.
                </span>
            </div>
        </div>

        <!---------------------------------------- Confirm Button ------------------------------------>
        <button [disabled]="!paymentPolicy || validateNumber.result || total < 10 || total > 1000"
            (click)="paymentPolicy ? payClick() : null"
            class="w-full h-[50px] rounded-2xl font-bold text-sm shadow-md transition-all duration-300 flex items-center justify-center gap-2 active:scale-[0.98] outline-none"
            [ngClass]="(paymentPolicy && !validateNumber.result && total >= 10 && total <= 1000) 
                ? 'bg-amber-400 hover:bg-amber-500 text-slate-800 shadow-amber-300/30' 
                : 'bg-slate-200 text-slate-400 cursor-not-allowed shadow-none'">
            <img *ngIf="(paymentPolicy && !validateNumber.result && total >= 10 && total <= 1000) "
                src="icons/electric_bolt_black.svg" />
            <img *ngIf="!(paymentPolicy && !validateNumber.result && total >= 10 && total <= 1000) "
                src="icons/electric_bolt_slate_dark.svg" />
            {{ currentLang === "TH" ? "ชำระเงิน" : "Payment" }}
        </button>
    </div>
</div>

<!---------------------------------------- Alerts and Loading Overlay ------------------------------------>
<app-pss-loading *ngIf="isLoading"></app-pss-loading>
<app-toast-warn *ngIf="isWarning" [isButton]="false" [timeIn]="3000" (close)="isWarning = $event"
    [detail]="textWarn"></app-toast-warn>
<app-toast-failed *ngIf="isError" [timeIn]="3000" (close)="isError = $event" [detail]="textError"></app-toast-failed>
<app-toast-success *ngIf="isSuccess" (close)="isSuccess = $event" [timeIn]="3000"
    [detail]="textSuccess"></app-toast-success>

<!---------------------------------------- Modal Thai QR code ------------------------------------>
<div class="fixed inset-0 z-[50] bg-black/50 flex items-center justify-center p-4" *ngIf="isThaiQR">
    <div class="bg-white rounded-3xl shadow-xl w-full max-w-sm overflow-hidden text-center animate-fade-in-up">
        <div class="custom-bg-head-pay text-white text-2xl flex items-center justify-center p-4 bg-slate-900">
            <img src="./icons/ThaiQR-removebg.png" class="w-40 h-[50px] object-cover" />
        </div>

        <div class="p-6">
            <div
                class="w-60 h-60 mx-auto bg-slate-50 border border-slate-100 rounded-2xl flex items-center justify-center p-2 mb-4">
                <img [src]="qrImageUrl" alt="Thai QR Code" class="w-full h-full object-contain" />
            </div>

            <p class="text-xl font-black text-emerald-600 mb-6">
                {{ currentLang === "TH" ? "ยอดชำระ" : "Amount" }}: {{ total | number }} {{ currentLang === "TH" ? "บาท"
                : "Baht" }}
            </p>

            <p class="text-rose-500 text-xs mb-6">{{ currentLang === "TH"
                ? "*กรุณากดบันทึกรูปภาพหน้าจอเพื่อบันทึก QR code"
                : "*Please save the QR code screenshot" }}</p>
            <div class="space-y-2">
                <button
                    class="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-2xl active:scale-95 transition-all shadow-sm flex items-center justify-center gap-1.5"
                    (click)="checkPaymentTopup()">
                    <img src="icons/check_circle_white.svg" class="w-6 h-6" />
                    {{ currentLang === "TH" ? "ชำระเงินสำเร็จแล้ว" : "Payment Completed" }}
                </button>

                <button
                    class="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-600 font-bold rounded-2xl active:scale-95 transition-all"
                    (click)="close()">
                    {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
                </button>
            </div>
        </div>
    </div>
</div>

<!---------------------------------------- Modal Notice (app-pss-warn) -------------------------------------->
<app-pss-warn *ngIf="modalNotice" [isButtonConfirm]="true" [language]="currentLang"
    (submit)="submitNoticeEvcharger($event)" (close)="closeNoticeEvcharger($event)" [detail]="currentLang === 'TH'
      ? 'ตอนนี้เติมเงินสามารถใช้ได้กับ EV Charger เท่านั้น!'
      : 'Top-up credits can currently be used for EV chargers only.'">
</app-pss-warn>

<!---------------------------------------- Modal Custom Price ------------------------------------>
<div class="fixed inset-0 z-[50] bg-black/50 flex items-center justify-center p-4" *ngIf="modalFixedAmount">
    <div class="bg-white rounded-3xl w-full max-w-xs p-6 space-y-4 shadow-xl text-center animate-fade-in-up">
        <div class="space-y-1">
            <h3 class="text-base font-black text-slate-800">
                {{ currentLang === "TH" ? "กำหนดราคาเติมเงิน" : "Custom Top Up Amount" }}
            </h3>
            <p class="text-xs text-slate-400">
                {{ currentLang === "TH" ? "กรอกจำนวนเงินที่คุณต้องการเติม" : "Enter the amount you wish to top up" }}
            </p>
        </div>

        <div
            class="relative flex items-center border-b border-slate-200 py-1.5 focus-within:border-amber-400 transition-colors">
            <span class="text-lg font-bold text-slate-400">฿</span>
            <input
                class="w-full pl-3 bg-transparent text-lg font-bold text-slate-700 placeholder-slate-300 focus:outline-none"
                [(ngModel)]="figPrice" type="number" placeholder="0.00" />
        </div>

        <div class="grid grid-cols-2 gap-2 pt-2">
            <button
                class="py-3 rounded-2xl bg-amber-400 text-slate-800 font-bold text-sm hover:bg-amber-500 active:scale-95 transition-all shadow-sm shadow-amber-300/20"
                (click)="confirmToFixedAmount()">
                {{ currentLang == "TH" ? "ตกลง" : "OK" }}
            </button>
            <button
                class="py-3 rounded-2xl bg-slate-100 text-slate-600 font-bold text-sm hover:bg-slate-200 active:scale-95 transition-all"
                (click)="changeToFixedAmount()">
                {{ currentLang == "TH" ? "ยกเลิก" : "Cancel" }}
            </button>
        </div>
    </div>
</div>

<!---------------------------------------- Modal Confirm (Unused placeholder kept for structure) ------------------------------------>
<div class="fixed inset-0 z-[50] bg-black bg-opacity-50 flex items-center justify-center p-4"
    *ngIf="modalConfirmPayment">
    <div class="bg-white rounded-3xl w-full max-w-xs p-6 space-y-4 shadow-xl text-center">
        <button
            class="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-600 font-bold rounded-2xl active:scale-95 transition-all"
            (click)="this.modalConfirmPayment = !this.modalConfirmPayment">
            {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
        </button>
    </div>
</div>